<!-- @format -->

<div class="paginationControlContainer">
  <div class="paginationControl" #paginationControl>
    <!-- Render it in the elongated list mode -->
    @if (paginationDisplayStyle === DisplayStyles.Inline) {
      <button class="firstPageBtn" (click)="goToFirstPage()" [disabled]="shouldDisablePrevBtns">
        <i class="fa-solid fa-chevrons-left"></i>
        <span>&nbsp;First</span>
      </button>
      <button class="previousPageBtn" (click)="goToPrevPage()" [disabled]="shouldDisablePrevBtns">
        <i class="fa-solid fa-chevron-left"></i>
        <span>&nbsp;Previous</span>
      </button>
      <div class="paginationPageNumberContainer">
        @if (currentListDisplayed === DisplayedList.Initial) {
          @for (pageNum of paginationKeysStart; track pageNum) {
            <div (click)="goToSpecificPage(pageNum)" class="{{paginationCurrentPage === pageNum ? 'currentPaginationPage' : ''}}">
              <span>{{pageNum}}</span>
            </div>
          }
          @if (!paginationKeysStart.includes(paginationLastPage)) {
            <div class="ellipses">...</div>
            <div class="{{paginationCurrentPage === paginationLastPage ? 'currentPaginationPage' : ''}}" (click)="goToLastPage()">
              <span>{{paginationLastPage}}</span>
            </div>
          }
        }
        @if (currentListDisplayed === DisplayedList.Middle) {
          <div (click)="goToFirstPage()"><span>1</span></div>
          <div class="ellipses">...</div>
          <div class="prevPageNumber" (click)="goToPrevPage()">
            <span>{{paginationCurrentPage - 1}}</span>
          </div>
          <div class="currentPaginationPage">
            <span>{{paginationCurrentPage}}</span>
          </div>
          <div class="nextPageNumber" (click)="goToNextPage()">
            <span>{{paginationCurrentPage + 1}}</span>
          </div>
          <div class="ellipses">...</div>
          <div (click)="goToLastPage()">
            <span>{{paginationLastPage}}</span>
          </div>
        }
        @if (currentListDisplayed === DisplayedList.Final) {
          <div (click)="goToFirstPage()"><span>1</span></div>
          <div class="ellipses">...</div>
          @for (pageNum of paginationKeysEnd; track pageNum) {
            <div class="{{paginationCurrentPage === pageNum ? 'currentPaginationPage' : ''}}" (click)="goToSpecificPage(pageNum)">
              <span>{{pageNum}}</span>
            </div>
          }
        }
      </div>
      <button class="nextPageBtn" (click)="goToNextPage()" [disabled]="shouldDisableNextBtns">
        <span>Next&nbsp;</span>
        <i class="fa-solid fa-chevron-right"></i>
      </button>
      <button class="lastPageBtn" (click)="goToLastPage()" [disabled]="shouldDisableNextBtns">
        <span>Last&nbsp;</span>
        <i class="fa-solid fa-chevrons-right"></i>
      </button>
    }

    <!-- Render it in the stacked list mode -->
    @if (paginationDisplayStyle === DisplayStyles.Stacked) {
      <div class="stackedPaginationControls">
        <div class="paginationPageNumberContainer">
          @if (currentListDisplayed === DisplayedList.Initial) {
            @for (pageNum of paginationKeysStart; track pageNum) {
              <div class="{{paginationCurrentPage === pageNum ? 'currentPaginationPage' : ''}}" (click)="goToSpecificPage(pageNum)">
                <span>{{pageNum}}</span>
              </div>
            }
            @if (!paginationKeysStart.includes(paginationLastPage)) {
              <div class="ellipses">...</div>
              <div class="{{paginationCurrentPage === paginationLastPage ? 'currentPaginationPage' : ''}}" (click)="goToLastPage()">
                <span>{{paginationLastPage}}</span>
              </div>
            }
          }
          @if (currentListDisplayed === DisplayedList.Middle) {
            @if (paginationNumberListSize === DisplayModes.Full) {
              <div (click)="goToFirstPage()"><span>1</span></div>
            }
            <div class="ellipses">...</div>
            <div class="prevPageNumber" (click)="goToPrevPage()">
              <span>{{paginationCurrentPage - 1}}</span>
            </div>
            <div class="currentPaginationPage">
              <span>{{paginationCurrentPage}}</span>
            </div>
            <div class="nextPageNumber" (click)="goToNextPage()">
              <span>{{paginationCurrentPage + 1}}</span>
            </div>
            <div class="ellipses">...</div>
            @if (paginationNumberListSize === DisplayModes.Full) {
              <div (click)="goToLastPage()">
                <span>{{paginationLastPage}}</span>
              </div>
            }
          }
          @if (currentListDisplayed === DisplayedList.Final) {
            <div (click)="goToFirstPage()"><span>1</span></div>
            <div class="ellipses">...</div>
            @for (pageNum of paginationKeysEnd; track pageNum) {
              <div class="{{paginationCurrentPage === pageNum ? 'currentPaginationPage' : ''}}" (click)="goToSpecificPage(pageNum)">
                <span>{{pageNum}}</span>
              </div>
            }
          }
        </div>
        <div class="paginationCompressedNavBtns">
          <div class="paginationNavBtnsLeft">
            <button class="firstPageBtn" (click)="goToFirstPage()" [disabled]="shouldDisablePrevBtns">
              <i class="fa-solid fa-chevrons-left"></i>
            </button>
            <button class="previousPageBtn" (click)="goToPrevPage()" [disabled]="shouldDisablePrevBtns">
              <i class="fa-solid fa-chevron-left"></i>
            </button>
          </div>
          <div class="paginationNavBtnsRight">
            <button class="nextPageBtn" (click)="goToNextPage()" [disabled]="shouldDisableNextBtns">
              <i class="fa-solid fa-chevron-right"></i>
            </button>
            <button class="lastPageBtn" (click)="goToLastPage()" [disabled]="shouldDisableNextBtns">
              <i class="fa-solid fa-chevrons-right"></i>
            </button>
          </div>
        </div>
      </div>
    }
  </div>
</div>
